import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {ExperimentNames, getEventId, getEventTitle} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronRight} from '@wix/wix-ui-icons-common'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useEventDateInformation} from '../../../../../../../../../../commons/hooks/dates'
import {isMultiDay} from '../../../../../../../../../../commons/selectors/event'
import {useWidgetState} from '../../../../../../../hooks/state-provider'
import {getMultiDayText} from '../../../../../../../selectors/events'
import s from '../monthly-calendar-event-list.scss'
import {MonthlyCalendarEventListItemProps} from './interfaces'

export const MonthlyCalendarEventListItem = ({selectedDate, event, onClick}: MonthlyCalendarEventListItemProps) => {
  const {t} = useTranslation()
  const eventId = getEventId(event)
  const {startDate, startTime} = useEventDateInformation(eventId)
  const {experiments} = useExperiments()
  const multiDay = useWidgetState(state => isMultiDay(state, event))
  const multiDayText = useWidgetState(state => getMultiDayText(state, eventId, selectedDate, t))

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)

  return (
    <li
      className={s.event}
      onClick={onClick}
      onKeyDown={handleKeyPressEnterOrSpace(onClick)}
      tabIndex={0}
      data-hook={DH.calendarEventListItem(eventId)}
    >
      <div className={s.info}>
        {calendarRevampEnabled ? (
          <>
            <div className={s.title} data-hook={`event-title-${eventId}`}>
              {getEventTitle(event)}
            </div>
            <div className={s.time} data-hook={`event-time-${eventId}`}>
              {multiDay ? multiDayText : startTime}
            </div>
          </>
        ) : (
          <>
            <div className={s.time} data-hook={`event-time-${eventId}`}>
              {multiDay ? multiDayText : startDate}
            </div>
            <div className={s.oldTitle} data-hook={`event-title-${eventId}`}>
              {getEventTitle(event)}
            </div>
          </>
        )}
      </div>
      {!calendarRevampEnabled && (
        <div className={s.chevron}>
          <ChevronRight size="1.6em" />
        </div>
      )}
    </li>
  )
}
